<template>
  <div>
    <div class="text-left v-mb-sm">
      <a-select v-model="range" placeholder="统计范围" style="width: 200px">
        <a-select-option :value="1">统计 - 今年新增项目</a-select-option>
        <a-select-option :value="2">统计 - 执行中的项目</a-select-option>
        <a-select-option :value="3">统计 - 全部项目</a-select-option>
      </a-select>
    </div>
    <a-row :gutter="16">
      <a-col :span="24">
        <a-spin :spinning="statLoading">
          <a-card title="项目汇总">
            <div class="stat-container">
              <div class="info-stat justify-around" style="height: 130px">
                <div class="stat-item">
                  <div ref="noReview" class="stat-value text-indigo">
                    <span ref="count" style="font-size: 20px">{{ statInfo.count.toFixed(0) }}</span>
                    <i>个</i>
                  </div>
                  <div class="stat-field">项目总数</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span ref="budgetAmount" style="font-size: 20px">{{ $utils.thousands(statInfo.budgetAmount, 2) }}</span>
                    <i>元</i>
                  </div>
                  <div class="stat-field">预算金额合计</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span ref="appliedAmount" style="font-size: 20px">{{ $utils.thousands(statInfo.appliedAmount, 2) }}</span>
                    <i>元</i>
                  </div>
                  <div class="stat-field">请款金额合计</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span ref="expensedAmount" style="font-size: 20px">{{ $utils.thousands(statInfo.expensedAmount, 2) }}</span>
                    <i>元</i>
                  </div>
                  <div class="stat-field">实际支出金额合计</div>
                </div>
              </div>
            </div>
          </a-card>
        </a-spin>
      </a-col>
      <!-- <a-col :span="17">
        <a-card title="按分类统计">
          <div class="info-stat justify-between v-px-md" style="height: 130px">
            <div class="stat-item2">
              <div class="stat-field">公募合作</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOwn">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOwn" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">专项基金</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountFunded">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountFunded" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">螺蛳壳改造</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOther">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOther" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">精灵书屋</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOther">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOther" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">公益人才</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOther">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOther" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">爱心100</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOther">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOther" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
            <div class="stat-item2">
              <div class="stat-field">其他项目</div>
              <div ref="noReview" class="stat-value text-indigo">
                <span ref="projectCountOther">0</span>
                <i>个</i>
              </div>
              <div class="stat-field v-mt-xs">预算金额</div>
              <div ref="noReview" class="stat-value text-primary">
                <span ref="projectAmountOther" style="font-size: 20px">0</span>
                <i>元</i>
              </div>
            </div>
          </div>
        </a-card>
      </a-col> -->
    </a-row>
    <a-row :gutter="16" class="v-my-md font-special">
      <a-col :span="24">
        <a-card title="项目分类统计" :body-style="{ padding: 0 }">
          <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="statLoading" :data-source="statList" :scroll="{ x: '100%' }" rowKey="type" :custom-row="customRow">
            <a-table-column title="" :width="10" data-index="place1" align="right"></a-table-column>
            <a-table-column title="项目类型" data-index="type" :width="200" align="left">
              <template slot-scope="text, record">
                <span class="text-bold text-indigo" v-if="record.sum">合计</span>
                <template v-else>
                  <span v-if="text === 11">合作项目—公募合作</span>
                  <span v-else-if="text === 12">合作项目—专项基金</span>
                  <span v-else-if="text === 21">自有项目—螺蛳壳改造</span>
                  <span v-else-if="text === 22">自有项目—精灵书屋</span>
                  <span v-else-if="text === 23">自有项目—公益人才</span>
                  <span v-else-if="text === 24">自有项目—爱心100</span>
                  <span v-else-if="text === 25">自有项目—其他项目</span>
                </template>
              </template>
            </a-table-column>
            <a-table-column title="项目数" data-index="count" align="right">
              <template slot-scope="text, record">
                <span :class="{ 'text-bold text-indigo': record.sum }">
                  {{ record.count }}
                </span>
              </template>
            </a-table-column>
            <a-table-column title="预算金额合计" data-index="budgetAmount" align="right">
              <template slot-scope="text, record">
                <span :class="{ 'text-bold text-primary': record.sum }">
                  {{ $utils.thousands(record.budget_amount) }}
                </span>
              </template>
            </a-table-column>
            <a-table-column title="请款金额合计" data-index="appliedAmount" align="right">
              <template slot-scope="text, record">
                <span :class="{ 'text-bold text-primary': record.sum }">
                  {{ $utils.thousands(record.applied_amount) }}
                </span>
              </template>
            </a-table-column>
            <a-table-column title="实际支出金额合计" data-index="expensedAmount" align="right">
              <template slot-scope="text, record">
                <span :class="{ 'text-bold text-primary': record.sum }">
                  {{ $utils.thousands(record.expensed_amount) }}
                </span>
              </template>
            </a-table-column>
            <a-table-column title="" :width="10" data-index="place1" align="right"></a-table-column>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="16" class="font-special" v-if="range == 1">
      <a-col :span="24">
        <a-card title="项目按月统计" :body-style="{ padding: 0 }">
          <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="monthList" :scroll="{ x: '100%' }" rowKey="month">
            <a-table-column title="月份" data-index="month" :width="90" align="center">
              <template slot-scope="text, record">
                {{ record.month }}
              </template>
            </a-table-column>
            <a-table-column title="当月新增项目预算金额合计" data-index="amount" align="right">
              <template slot-scope="text, record">
                {{ $utils.thousands(record.amount) }}
              </template>
            </a-table-column>
            <a-table-column title="今年以来新增项目预算金额合计" data-index="amountByYear" align="right">
              <template slot-scope="text, record">
                {{ $utils.thousands(record.amountByYear) }}
              </template>
            </a-table-column>
            <a-table-column title="" :width="10" data-index="place1" align="right"></a-table-column>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { statProject } from '@/api/stat'
import gsap from 'gsap'
export default {
  name: 'StatProject',
  data() {
    return {
      range: 1,
      loading: false,
      statLoading: false,
      statInfo: {
        count11: 0,
        count12: 0,
        count21: 0,
        count22: 0,
        count23: 0,
        count24: 0,
        count25: 0,
        budgetAmount11: 0,
        budgetAmount12: 0,
        budgetAmount21: 0,
        budgetAmount22: 0,
        budgetAmount23: 0,
        budgetAmount24: 0,
        budgetAmount25: 0,
        count: 0,
        budgetAmount: 0,
        appliedAmount: 0,
      },
      subjectChartOption: {},
      districtChartOption: {},
      monthList: [],
      statList: [],
      monthStat: {},
    }
  },
  computed: {
    subjects: vm => vm.$store.state.app.subjects,
  },
  watch: {
    range() {
      this.init()
    },
  },
  methods: {
    init() {
      this.loadStatinfo(this.range)
    },
    loadStatinfo(range) {
      let vm = this
      this.statLoading = false
      statProject(range).then(({ data }) => {
        if (data.success) {
          this.range = range
          let { stat, month } = data.result
          let count11 = 0,
            budgetAmount11 = 0,
            expensedAmount11 = 0,
            appliedAmount11 = 0,
            raisedAmount11 = 0
          let count12 = 0,
            budgetAmount12 = 0,
            expensedAmount12 = 0,
            appliedAmount12 = 0,
            raisedAmount12 = 0
          let count21 = 0,
            budgetAmount21 = 0,
            expensedAmount21 = 0,
            appliedAmount21 = 0,
            raisedAmount21 = 0
          let count22 = 0,
            budgetAmount22 = 0,
            expensedAmount22 = 0,
            appliedAmount22 = 0,
            raisedAmount22 = 0
          let count23 = 0,
            budgetAmount23 = 0,
            expensedAmount23 = 0,
            appliedAmount23 = 0,
            raisedAmount23 = 0
          let count24 = 0,
            budgetAmount24 = 0,
            expensedAmount24 = 0,
            appliedAmount24 = 0,
            raisedAmount24 = 0
          let count25 = 0,
            budgetAmount25 = 0,
            expensedAmount25 = 0,
            appliedAmount25 = 0,
            raisedAmount25 = 0
          stat.forEach(item => {
            if (item.type == 11) {
              count11 += item.count || 0
              budgetAmount11 += item.budget_amount || 0
              expensedAmount11 += item.expensed_amount || 0
              appliedAmount11 += item.applied_amount || 0
              raisedAmount11 += item.raised_amount || 0
            } else if (item.type == 12) {
              count12 += item.count || 0
              budgetAmount12 += item.budget_amount || 0
              expensedAmount12 += item.expensed_amount || 0
              appliedAmount12 += item.applied_amount || 0
              raisedAmount12 += item.raised_amount || 0
            } else if (item.type == 21) {
              count21 += item.count || 0
              budgetAmount21 += item.budget_amount || 0
              expensedAmount21 += item.expensed_amount || 0
              appliedAmount21 += item.applied_amount || 0
              raisedAmount21 += item.raised_amount || 0
            } else if (item.type == 22) {
              count22 += item.count || 0
              budgetAmount22 += item.budget_amount || 0
              expensedAmount22 += item.expensed_amount || 0
              appliedAmount22 += item.applied_amount || 0
              raisedAmount22 += item.raised_amount || 0
            } else if (item.type == 23) {
              count23 += item.count || 0
              budgetAmount23 += item.budget_amount || 0
              expensedAmount23 += item.expensed_amount || 0
              appliedAmount23 += item.applied_amount || 0
              raisedAmount23 += item.raised_amount || 0
            } else if (item.type == 24) {
              count24 += item.count || 0
              budgetAmount24 += item.budget_amount || 0
              expensedAmount24 += item.expensed_amount || 0
              appliedAmount24 += item.applied_amount || 0
              raisedAmount24 += item.raised_amount || 0
            } else if (item.type == 25) {
              count25 += item.count || 0
              budgetAmount25 += item.budget_amount || 0
              expensedAmount25 += item.expensed_amount || 0
              appliedAmount25 += item.applied_amount || 0
              raisedAmount25 += item.raised_amount || 0
            }
          })
          let statInfo = {
            count11,
            count12,
            count21,
            count22,
            count23,
            count24,
            count25,
            budgetAmount11,
            budgetAmount12,
            budgetAmount21,
            budgetAmount22,
            budgetAmount23,
            budgetAmount24,
            budgetAmount25,
            count: count11 + count12 + count21 + count22 + count23 + count24 + count25,
            budgetAmount: budgetAmount11 + budgetAmount12 + budgetAmount21 + budgetAmount22 + budgetAmount23 + budgetAmount24 + budgetAmount25,
            appliedAmount: appliedAmount11 + appliedAmount12 + appliedAmount21 + appliedAmount22 + appliedAmount23 + appliedAmount24 + appliedAmount25,
            expensedAmount: expensedAmount11 + expensedAmount12 + expensedAmount21 + expensedAmount22 + expensedAmount23 + expensedAmount24 + expensedAmount25,
          }
          stat.push({
            type: 0,
            sum: true,
            count: count11 + count12 + count21 + count22 + count23 + count24 + count25,
            raised_amount: raisedAmount11 + raisedAmount12 + raisedAmount21 + raisedAmount22 + raisedAmount23 + raisedAmount24 + raisedAmount25,
            applied_amount: appliedAmount11 + appliedAmount12 + appliedAmount21 + appliedAmount22 + appliedAmount23 + appliedAmount24 + appliedAmount25,
            budget_amount: budgetAmount11 + budgetAmount12 + budgetAmount21 + budgetAmount22 + budgetAmount23 + budgetAmount24 + budgetAmount25,
            expensed_amount: expensedAmount11 + expensedAmount12 + expensedAmount21 + expensedAmount22 + expensedAmount23 + expensedAmount24 + expensedAmount25,
          })
          this.statList = stat
          gsap.to(vm.statInfo, 0.75, {
            ...statInfo,
          })
          let monthList = Object.keys(month).map(m => ({
            month: m,
            amount: month[m],
            amountByYear: 0,
          }))
          monthList.forEach((m, i) => {
            m.amountByYear = i === 0 ? m.amount : m.amount + monthList[i - 1].amountByYear
          })
          this.monthList = monthList
        }
        // this.statLoading = false
      })
    },
    customRow(record) {
      return {
        props: {
          class: record.sum ? 'bg-indigo' : 'row-item',
        },
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>
